import { useContext } from "react";
import { Redirect } from "react-router";

import { BuilderInfoContext } from "helpers/globalContext/BuilderInfoContext";

import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type IWarrantyProps } from "entity/warranty/Warranty/Warranty";

const Warranty = lazyLoadWithRetry(() => import("./Warranty"));

export const RouteWarranty = (
    props: Omit<IWarrantyProps, "id" | "jobId" | "history" | "match" | "location">,
) => {
    const builderInfo = useContext(BuilderInfoContext);

    return (
        <RouteRelative
            path={routes.warranty.details}
            render={(routeProps) => {
                const id = parseInt(routeProps.match.params.id);
                const jobId = parseInt(routeProps.match.params.jobId);

                // warrantiesModalConversion: redirect the legacy bookmarked modal URL
                // (`/Warranties/Warranty/:id/:jobId[/Service/...]`) to the standalone
                // warranty page so pre-conversion bookmarks land on the page instead of
                // the modal. This `RouteRelative` match is non-exact, so any trailing
                // `/Service/:serviceId/:completed` segment lives in the un-matched tail
                // of the path; we carry it over verbatim so a service deep-link redirects
                // to page+service. When the flag is removed this becomes the unconditional
                // behavior and is the only thing left at the old nested path.
                if (builderInfo?.flags.warrantiesModalConversion) {
                    const serviceSubPath = routeProps.location.pathname.slice(
                        routeProps.match.url.length,
                    );
                    return (
                        <Redirect to={routes.warranty.getDetailsLink(id, jobId) + serviceSubPath} />
                    );
                }

                return (
                    <BTSuspense>
                        <Warranty {...props} {...routeProps} id={id} jobId={jobId} />
                    </BTSuspense>
                );
            }}
        />
    );
};
